import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setStage } from 'slices/drawer'
import { FIREBASE_EVENTS } from 'app-constants'
import { getEnjoyNowLink, getTvButtonInfo, hasIntegrationErrorTvPlan } from 'utils'
import { useFirebaseEvent } from 'hooks'
import { fetchContractDetails, fetchTvPlansActivationLink } from 'slices/contract'
import { DETAILS_SVA_STAGES } from '../../constants'
import './style.scss'

export function DetailsSva({ additional }) {
  const { sendEvent } = useFirebaseEvent()
  const {
    itemCode,
    itemName: name,
    description,
    imageUrl: banner,
    urlDocument,
    status,
    activeSva,
    integrationError,
  } = additional
  const {
    activationLinks,
    selected: { id: idContract },
  } = useSelector(({ contract }) => contract)
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(fetchContractDetails(idContract))
    dispatch(fetchTvPlansActivationLink())
  }, [dispatch, idContract])

  function handleGoToWebsiteClick() {
    sendEvent(FIREBASE_EVENTS.CLICK_ON_SVA_GO_TO_WEBSITE)
  }

  function handleActivateClick(e) {
    const hasIntegrationError = hasIntegrationErrorTvPlan(additional)

    if (hasIntegrationError) {
      e.preventDefault()
      dispatch(setStage(DETAILS_SVA_STAGES.INTEGRATION_ERROR))
    } else {
      handleGoToWebsiteClick()
    }
  }

  function getActivationLink() {
    const activationLinkInfo = activationLinks.find(({ tvPlanKey }) => tvPlanKey === itemCode)

    return activationLinkInfo?.activationLink
  }

  function renderSvaEnjoyNowButton() {
    const link = getEnjoyNowLink(itemCode)

    if (!link) return null

    return (
      <a
        href={link}
        target='_blank'
        rel='noopener noreferrer'
        className='link'
        onClick={handleGoToWebsiteClick}
      >
        Aproveite Agora
      </a>
    )
  }

  function renderManualPdf() {
    if (!urlDocument) return null

    return (
      <a
        href={urlDocument}
        target='_blank'
        rel='noopener noreferrer'
        className='link'
        onClick={handleGoToWebsiteClick}
      >
        Manual de ativação
      </a>
    )
  }

  function renderButtonSignature() {
    const activationLink = getActivationLink()
    const buttonInfo = getTvButtonInfo({ activeSva, status, integrationError }, activationLink)

    if (buttonInfo) {
      return (
        <a
          href={buttonInfo.link}
          target='_blank'
          rel='noopener noreferrer'
          className='link'
          onClick={e => handleActivateClick(e)}
        >
          {buttonInfo.label}
        </a>
      )
    }

    return renderSvaEnjoyNowButton()
  }

  return (
    <div className='container-details-sva'>
      <div className='container-banner'>
        <img alt={`Banner do produto ${name}`} className='image' src={banner} />
      </div>
      <div className='container-info'>
        <span className='title'>{name}</span>
        <span className='description'>{description}</span>
      </div>
      <div className='container-buttons'>
        {renderButtonSignature()}
        {renderManualPdf()}
      </div>
    </div>
  )
}
